import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import FormHelperText from '@mui/material/FormHelperText'
import InputLabel from '@mui/material/InputLabel'

const verticalMenuItemSx = {
  '&&': {
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'flex-start',
    textAlign: 'left',
    width: '100%'
  }
}

const menuPaperSx = {
  '& .MuiMenu-list': {
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column'
  },
  '& li': {
    display: 'flex',
    justifyContent: 'flex-start',
    textAlign: 'left',
    width: '100%'
  }
}

const CustomSelect = ({
  className,
  disabled,
  onChange,
  options,
  value,
  helperText,
  optionLabelKey,
  optionIdKey,
  validation,
  label,
  disabledValue,
  children
}) => {
  const MenuProps = {
    PaperProps: { sx: menuPaperSx },
    MenuListProps: {
      sx: {
        '&&': {
          alignItems: 'stretch',
          display: 'flex',
          flexDirection: 'column'
        }
      }
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }

  const handleChange = (e) => {
    const value = e.target.value

    if (value) {
      onChange(value)
    }
  }

  const helperTextMenuItem = (
    <MenuItem value='' disabled sx={verticalMenuItemSx}>
      <em>{helperText}</em>
    </MenuItem>
  )

  const renderOptions = () => {
    if (children) return children

    return options.map((option, key) => (
      <MenuItem
        key={key}
        value={optionIdKey ? option[optionIdKey] : option}
        sx={verticalMenuItemSx}
        disabled={
          optionIdKey
            ? option[optionIdKey] === disabledValue
            : option === disabledValue
        }
      >
        {optionLabelKey ? option[optionLabelKey] : option}
      </MenuItem>
    ))
  }

  return (
    <FormControl
      className={className}
      variant='outlined'
      error={Boolean(validation)}
      sx={(theme) => ({
        width: '100%',
        '& .MuiSelect-select': {
          background: theme.palette.quaternary.main,
          borderRadius: '4px',
          color: theme.palette.primary.main,
          fontFamily: 'Roboto, sans-serif',
          margin: 0,
          padding: label ? '10px 13px 0px' : '5px 13px'
        },
        '& .MuiFormLabel-root': { color: theme.palette.primary.main },
        '& .MuiInputBase-root': {
          border: `1px solid ${theme.palette.primary.main}`
        },
        '& .MuiOutlinedInput-notchedOutline': { border: 'none' }
      })}
    >
      <InputLabel
        variant='standard'
        id='label'
        sx={(theme) => ({
          color: theme.palette.primary.main,
          fontFamily: 'Lato, sans-serif',
          fontSize: '15px',
          left: '5px',
          zIndex: 2
        })}
      >
        {label}
      </InputLabel>
      <Select
        labelId='label'
        id='simple-dropdown'
        MenuProps={MenuProps}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        displayEmpty
        sx={{ '&& .MuiSelect-select': { textAlign: 'left' } }}
      >
        {helperText && helperTextMenuItem}
        {renderOptions()}
      </Select>
      {validation && <FormHelperText>{validation}</FormHelperText>}
    </FormControl>
  )
}

export default CustomSelect
